import { path, sortBy, values } from 'ramda';
import { createSelector } from 'reselect';

const getGifts = state => state.gifts.list;

export const sortBySpace = createSelector(getGifts, gifts => sortBy(path(['space', 'original']), values(gifts)));
export const getAvaliableGifts = createSelector(sortBySpace, gifts => gifts.filter(gift => gift.available));
export const getGiftById = createSelector(getGifts, (state, id) => id, (list, id) => list[id]);
